import { createAction } from "@reduxjs/toolkit";

export const restorePersistedState = createAction(
  'persistence/restoreState'
);